import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse, handleErrorWithoutRedirect } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'v1/tfa'
const plural = 'tfas'
const single = 'tfa'

const twoFactorAuthenticatication = new ApiCore({
	index: true,
	create: true,
	url: url,
	plural: plural,
	single: single
})

twoFactorAuthenticatication.generateTfa = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/secretkey`)
		.then(handleResponse)
		.catch(handleError);
}

twoFactorAuthenticatication.verifyTfa = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/verifytfa`,payload)
		.then(handleResponse)
		.catch(handleErrorWithoutRedirect);
}

twoFactorAuthenticatication.validateTfa = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/validatetfa`, payload)
		.then(handleResponse)
		.catch(handleErrorWithoutRedirect);
}

export default twoFactorAuthenticatication
